import React from 'react';
import './Skeleton.css';

const Shimmer = () => {
    return (
        <div className="shimmer-container">
            <div className="shimmer"></div>
        </div>
    )
}

export default Shimmer;
